import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WalletItem } from "@components-shared/desktop/inputs/WalletItem";
import { useRootAppStore } from "@hooks";
import { WithdrawalContext } from "@state/context/payment/WithdrawalContext";
import { observer } from "mobx-react-lite";

export default observer(function SelectedWithdrawalWallet() {
	const { currentFormData } = useContext(WithdrawalContext);
	const { t } = useTranslation("payment");
	const rootStore = useRootAppStore();
	const selectedWallet = rootStore.userAuthStore.userAccounts?.find((w) => {
		return w.accountTypeId === currentFormData?.bettingAccountTypeId;
	});

	return (
		<>
			<div className="label">
				{t("WITHDRAWAL.SELECTED_WITHDRAWAL_WALLET")}
			</div>
			<ul className="wallet">
				<WalletItem
					wallet={selectedWallet}
					isDisabled
					isDefaultChecked
					shouldRegister={false}
					isList={true}
				/>
			</ul>
		</>
	);
});
